import React from "react"

import { FooterCopyright } from "./components/FooterCopyright"
import { LanguageSelector } from "./components/LanguageSelector"
import { MainLayout } from "./containers/MainLayout"
import { PageContent } from "./containers/PageContent"
import { NewsBlock } from "./providers/News/NewsBlock"
import { StartPageOutlet } from "./route/Outlet"

export const Page = () => (
  <MainLayout>
    <NewsBlock />
    <PageContent>
      <StartPageOutlet />
    </PageContent>
    <LanguageSelector />
    <FooterCopyright />
  </MainLayout>
)
